import React from "react";
import { HiOutlinePencil } from "react-icons/hi";
import { Link } from "react-router-dom";
import { PlusButton } from "../Buttons";
import { GrRevert } from "react-icons/gr";

interface BoxProps {
  children: React.ReactNode;
  className?: string;
  onEdit?: () => void;
  onAdd?: () => void;
  onBack?: () => void;
  onClick?: () => void;
  header?: string;
  headerLink?: string;
}

export const PaziaBox = ({ children, onEdit, onClick, onBack, onAdd, className, header, headerLink }: BoxProps) => {
  return (
    <>
      <div
        className={`group relative flex-grow rounded-xl border border-slate-200 bg-white p-4 shadow-lg dark:border-slate-700 dark:bg-slate-800 ${
          className ?? ""
        }`}
        onClick={onClick}
      >
        {onBack && (
          <GrRevert
            className="absolute right-2 top-2 cursor-pointer hover:text-slate-600 group-hover:block md:hidden"
            size={20}
            onClick={onBack}
            title="Wróć"
          />
        )}
        {onEdit && (
          <HiOutlinePencil
            className="absolute right-2 top-2 cursor-pointer hover:text-slate-600 group-hover:block md:hidden"
            size={20}
            onClick={onEdit}
            title="Edytuj"
          />
        )}
        {onAdd && <PlusButton onClick={onAdd} className="absolute right-2 top-2" />}
        {header && <PaziaBoxHeader headerLink={headerLink}>{header}</PaziaBoxHeader>}
        {children}
      </div>
    </>
  );
};

interface BoxHeaderProps {
  children: React.ReactNode;
  headerLink?: string;
}
export const PaziaBoxHeader = ({ children, headerLink }: BoxHeaderProps) => {
  if (headerLink) {
    return (
      <div className="text-center">
        <Link to={headerLink} className="font-semibold text-slate-800 hover:underline dark:text-slate-100">
          {children}
        </Link>
      </div>
    );
  }
  return <h2 className="text-center font-semibold text-slate-800 dark:text-slate-100">{children}</h2>;
};
